export function formatDate(date?: string) {
  const formatter = Intl.DateTimeFormat('pt-BR')
  if (!date) return formatter.format(new Date())
  return formatter.format(new Date(date))
}